var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-content pa-4 scroll-fire-fox" },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "", "justify-space-between": "", "align-start": "" } },
        [
          _c(
            "v-flex",
            {
              staticStyle: { height: "fit-content" },
              attrs: { xs12: "", md4: "" }
            },
            [
              _c("network-starting-point", {
                attrs: { "is-fixed": true, disabled: _vm.validationsAreRunning }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", {
            staticStyle: { height: "fit-content" },
            attrs: { xs12: "", md8: "" }
          }),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "mt-4", attrs: { xs12: "", md4: "" } },
            [
              _c("validation-selection", {
                on: {
                  updateRunState: function($event) {
                    _vm.validationsAreRunning = $event
                  },
                  selectResults: function($event) {
                    _vm.selectedResults = $event
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "mt-4", attrs: { xs12: "", md7: "" } },
            [
              _vm.selectedResults
                ? _c("error-selection", {
                    attrs: { "selected-results": _vm.selectedResults }
                  })
                : _c(
                    "v-card",
                    {
                      staticStyle: { color: "var(--v-secondary-darken1)" },
                      attrs: { color: "white", height: "100%" }
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          staticClass: "pa-5",
                          attrs: {
                            "fill-height": "",
                            column: "",
                            "justify-center": "",
                            "align-center": ""
                          }
                        },
                        [
                          _c("div", { staticClass: "message-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("NoValidationResultsSelected")) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "message-description" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("RunValidationSelectResults")) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c428acb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c428acb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Validations/ValidationsTab.vue
// module id = null
// module chunks = 